export default __webpack_public_path__ + "3158733.png";